import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col } from 'antd'
import ViewContainer from './container'
import { BBTabs } from 'components/Tabs'

const Styled = styled.div`
  .img-absolute {
    position: absolute;
  }
  .right-0 {
    right: 0;
  }

  .ant-tabs-nav {
    width: 100% !important;
  }

  .ant-tabs-tab {
    display: block; // centers text inside tabs
    flex: 1;
    text-align: center;
  }

  .ant-tabs-nav > div:nth-of-type(1) {
    display: unset !important;
    width: 100% !important;
  }
`

export default function Index ({ defaultKey, setIsLoading }) {
  return (
    <>
      <ViewContainer defaultKey={defaultKey} setIsLoading={setIsLoading}>
        {({ tabs, onChangeBBTabs }) => (
          <Styled className='px-4'>
            <Row>
              <Col className='mt-1' span={24}>
                <BBTabs
                  centered={true}
                  tabs={tabs}
                  defaultActiveKey={
                    defaultKey !== '' ? defaultKey : 'my-orders'
                  }
                  onChange={onChangeBBTabs}
                />
              </Col>
            </Row>
          </Styled>
        )}
      </ViewContainer>
    </>
  )
}

Index.propTypes = {
  setIsLoading: PropTypes.any,
  defaultKey: PropTypes.string
}
